var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg3 = function Svg3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 274 274"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 137,
    r: 137,
    fill: "url(#3_svg__a)",
    opacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFAF1",
    d: "M185.821 106.789v61.652c0 2.441-2.068 4.421-4.619 4.421H89.619c-2.552 0-4.619-1.98-4.619-4.421v-61.652z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFAF2",
    d: "M185.82 106.79v61.651c0 2.442-2.068 4.422-4.618 4.422h-11.33c2.552 0 4.62-1.98 4.62-4.422V106.79z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED5C2F",
    d: "M181.203 89H89.618C87.068 89 85 90.98 85 93.422v13.367h100.821V93.422c0-2.443-2.068-4.422-4.618-4.422"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAB331",
    fillOpacity: 0.3,
    d: "M152.478 133.359H95.063v22.4h57.415z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAB331",
    d: "M181.239 114.945c15.884 0 28.761-12.33 28.761-27.54s-12.877-27.54-28.761-27.54-28.761 12.33-28.761 27.54 12.877 27.54 28.761 27.54"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F28230",
    d: "M174.492 115.828H95.064v8.515h79.428z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M185.821 114.578v53.863c0 2.441-2.068 4.421-4.619 4.421H89.619c-2.552 0-4.619-1.98-4.619-4.421V106.79"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.064,
    cy: 163.226,
    fill: "#000",
    rx: 1.886,
    ry: 1.806
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M152.478 163.226h-50.537M152.478 133.359H95.063v22.4h57.415zM160.811 106.79h-75.81V93.421C85 90.98 87.068 89 89.618 89h62.86M91.808 97.894h18.757"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M181.239 114.945c15.884 0 28.761-12.33 28.761-27.54s-12.877-27.54-28.761-27.54-28.761 12.33-28.761 27.54 12.877 27.54 28.761 27.54M160.722 133.359h15.035M160.722 140.825h3.201M160.722 148.292h15.035M160.722 155.759h3.201M160.722 163.226h3.201"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M167.889 102.135c-2.491-2.386-2.491-6.253 0-8.639l3.227-3.09c2.491-2.385 6.53-2.385 9.021 0 2.491 2.386 2.491 6.253 0 8.639l-3.227 3.09c-2.491 2.385-6.53 2.385-9.021 0M183.688 87.007c-2.491-2.385-2.491-6.253 0-8.638l3.226-3.09c2.491-2.385 6.53-2.385 9.021 0s2.491 6.252 0 8.638l-3.227 3.09c-2.491 2.385-6.53 2.385-9.02 0M187.741 83.125l-11.658 11.163M174.492 115.828H95.064v8.515h79.428z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "3_svg__a",
    x1: 137,
    x2: 137,
    y1: 0,
    y2: 274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331",
    stopOpacity: 0
  })))));
};
export default Svg3;